import React from 'react';
import PropTypes from 'prop-types';
import { ResourceOverviewToolbarContext } from '~/modules/resource-management/ResourcingOverview/hooks';
import { useResourceManagementDashboardContextValue } from './hooks/useResourceManagementDashboardContext';

const ResourceManagementDashboardContextProvider = ({
  children,
  insightsSettings
}) => {
  const contextValues = useResourceManagementDashboardContextValue({
    insightsSettings
  });

  return (
    <ResourceOverviewToolbarContext.Provider value={contextValues}>
      {children}
    </ResourceOverviewToolbarContext.Provider>
  );
};

ResourceManagementDashboardContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
  insightsSettings: PropTypes.shape({
    displayUnit: PropTypes.string,
    periodScale: PropTypes.string,
    selectedView: PropTypes.string,
    groupBy: PropTypes.string,
    selectedProblem: PropTypes.string
  })
};

export default ResourceManagementDashboardContextProvider;
